
import createReducer from 'store/createReducer'
import { ActionType, type CustomerDataResponse } from 'store/customers/types'
import { Action, Nullable } from 'store/model'

import type { Customers } from 'types'


export interface ICustomersReducer {
  customers: Nullable<Customers>
  customer: Nullable<CustomerDataResponse>
}

const defaultState: ICustomersReducer = {
  customers: null,
  customer: null,
}

export const customersReducer = createReducer<ICustomersReducer>(defaultState, {
  [ActionType.SET_CUSTOMERS]: (state: ICustomersReducer, action: Action<Nullable<Customers>>) => ({
    ...state,
    customers: action.payload,
  }),

  [ActionType.SET_CUSTOMER]: (state: ICustomersReducer, action: Action<Nullable<CustomerDataResponse>>) => ({
    ...state,
    customer: action.payload,
  }),
})
